import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { getStocks } from '../../../api/Stock Management/api';

const StockSelector = ({ product, productId, value, onChange, onSelectStock, error, defaultStockId }) => {
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchStocks = async () => {
      if (product) {
        setLoading(true);
        try {
          const response = await getStocks({ product });
          setStocks(response.data);
        } catch (error) {
          console.error('Error fetching stocks:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchStocks();
  }, [product]);

  useEffect(() => {
    if (defaultStockId && !value) {
      setStocks(prev => prev);
      onChange({ target: { value: defaultStockId } });
      const selectedStock = stocks.find(s => s.id === defaultStockId);
      if (selectedStock && onSelectStock) {
        onSelectStock(selectedStock);
      }
    }
  }, [defaultStockId, value, stocks, onSelectStock]);

  const handleSelect = (e) => {
    const stockId = e.target.value;
    onChange(e);
    const selectedStock = stocks.find(s => s.id === stockId);
    if (selectedStock && onSelectStock) {
      onSelectStock(selectedStock);
    }
  };

  return (
    <FormControl fullWidth error={!!error}>
      <InputLabel>Select Stock</InputLabel>
      <Select
        value={value || ''}
        onChange={handleSelect}
        label="Select Stock"
        disabled={loading || !product}
        required
      >
        { 
          // Only display stocks that are available
          stocks
            .filter(stock => stock.status === "AVAILABLE")
            .filter(stock => stock.product_id === productId)
            .map((stock) => (
              <MenuItem key={stock.id} value={stock.id}>
                {`${stock.serving_warehouse} | ${stock.stock_region} | ${stock.available_quantity}`}
              </MenuItem>
            ))
        }
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default StockSelector;
